<span id="personSuspensionStatusChip-text-status" class="status-chip" [ngClass]="getStatusClass()">
  {{ getStatusText() }}
</span>
